{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-stock-exchange_2022-12-31/ssmt-stock-exchange_2022-12-31_role-110000",
  "definition": "[110000] Disclosure - Involvement in Stock Exchange",
  "sheetId": "StockExchangeDisclosure",
  "label": "Stock Exchange Disclosure",
  "controls": [
    {
      "qname": "ssmt:DateOfCompanyListedOnStockExchange",
      "label": "Date of company listed in Stock Exchange",
      "type": "Date",
      "ui": {
        "control": "date"
      },
      "warnings": [
        {
          "id": "date-of-listing-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "isEmpty",
            "message": "Kindly provide the \"Date of company listed in Stock Exchange\", if applicable."
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfExchangeOnWhichCompanyIsListed",
      "label": "Type of exchange on which company is listed",
      "type": "TypeOfExchangeListed",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfExchangeListed"
      },
      "warnings": [
        {
          "id": "type-of-exchange-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "isEmpty",
            "message": "Kindly select the \"Type of exchange on which company is listed\", if applicable."
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfForeignStockExchange",
      "label": "Disclosure of foreign stock exchange",
      "type": "String",
      "maxLength": 255,
      "ui": {
        "control": "text"
      },
      "warnings": [
        {
          "id": "foreign-exchange-disclosure-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "conditionalRequired",
            "message": "When \"Type of exchange on which company is listed\" is \"Bursa Malaysia and foreign stock exchange\" or \"Listed in foreign stock exchange only\", then \"Disclosure of foreign stock exchange\" SHOULD be reported.",
            "dependsOn": {
              "field": "ssmt:TypeOfExchangeOnWhichCompanyIsListed",
              "values": ["Bursa Malaysia and foreign stock exchange", "Listed in foreign stock exchange only"]
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfMarketListedOnBursaMalaysia",
      "label": "Type of market listed in Bursa Malaysia",
      "type": "TypeOfMarketListedInBursaMalaysia",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfMarketListedInBursaMalaysia"
      },
      "warnings": [
        {
          "id": "bursa-malaysia-market-type-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "conditionalRequired",
            "message": "When \"Type of exchange on which company is listed\" is \"Bursa Malaysia and foreign stock exchange\" or \"Bursa Malaysia\", then \"Type of market listed in Bursa Malaysia\" SHOULD be reported.",
            "dependsOn": {
              "field": "ssmt:TypeOfExchangeOnWhichCompanyIsListed",
              "values": ["Bursa Malaysia and foreign stock exchange", "Bursa Malaysia"]
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfSecuritiesListingOnShariahCompliantSecuritiesList",
      "label": "Disclosure of securities listing on Shari'ah compliant Securities list",
      "type": "DisclosureOfSecuritiesListingOnShariahCompliantSecuritiesList",
      "ui": {
        "control": "select",
        "enumSource": "type:DisclosureOfSecuritiesListingOnShariahCompliantSecuritiesList"
      },
      "warnings": [
        {
          "id": "shariah-compliant-disclosure-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "isEmpty",
            "message": "Kindly select the \"Disclosure of securities listing on Shari'ah compliant Securities list\", if applicable."
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:ExplanationOfOtherSecuritiesListedOnShariahComplaintSecuritiesList",
      "label": "Explanation of other securities listed on Shari'ah compliant Securities list",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4
      },
      "warnings": [
        {
          "id": "shariah-explanation-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "conditionalRequired",
            "message": "When \"Disclosure of securities listing on Shari'ah compliant Securities list\" is \"Others\", then \"Explanation of other securities listed on Shari'ah compliant Securities list\" SHOULD be reported.",
            "dependsOn": {
              "field": "ssmt:DisclosureOfSecuritiesListingOnShariahCompliantSecuritiesList",
              "values": ["Others"]
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DateOfDelistingOfShares",
      "label": "Date of delisting of shares",
      "type": "Date",
      "ui": {
        "control": "date"
      },
      "warnings": [
        {
          "id": "delisting-date-validation",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of delisting of shares\" should be less than \"Company's current financial year end date\".",
            "comparisonOperator": "gte",
            "compareWith": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:CompanyCurrentFinancialYearEndDate"
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:TypeOfExchangeFromWhichSharesWereDelisted",
      "label": "Type of exchange from which shares were delisted",
      "type": "TypeOfExchangeFromWhichShareWereDelisted",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfExchangeFromWhichShareWereDelisted"
      },
      "warnings": [
        {
          "id": "type-of-exchange-delisted-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "conditionalRequired",
            "message": "When \"Disclosure on whether company's shares are traded on any official stock exchange\" is \"Delisted\", then \"Type of exchange from which shares were delisted\" MUST be reported.",
            "dependsOn": {
              "sheet": "filingInfo",
              "field": "ssmt:DisclosureOnWhetherCompanysSharesAreTradedOnAnyOfficialStockExchange",
              "values": ["Delisted"]
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfForeignStockExchangeWhichCompanyWereDelisted",
      "label": "Disclosure of foreign stock exchange which the company were delisted",
      "type": "String",
      "maxLength": 255,
      "ui": {
        "control": "text"
      },
      "warnings": [
        {
          "id": "foreign-exchange-delisted-recommended",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "conditionalRequired",
            "message": "When \"Disclosure on whether company's shares are traded on any official stock exchange\" is \"Delisted\", then \"Disclosure of foreign stock exchange which the company were delisted\" MUST be reported.",
            "dependsOn": {
              "sheet": "filingInfo",
              "field": "ssmt:DisclosureOnWhetherCompanysSharesAreTradedOnAnyOfficialStockExchange",
              "values": ["Delisted"]
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    }
  ]
}
